{
  "assistantMemory.title": "Asistan hafızası ve etkinliği",
  "assistantMemory.lede": "Asistanın neleri hatırladığını inceleyin, yaptığı işlemleri görün ve yapay zekânın bir kayda nasıl katkıda bulunduğunu izleyin.",
  "assistantMemory.none": "Yok",
  "assistantMemory.error.generic": "Asistan hafızası güncellenemedi.",
  "assistantMemory.filter.sensitive": "Hassas hafızayı dahil et",
  "assistantMemory.filter.sensitiveHint": "Hassas öğeler siz görünür kılana kadar gizli kalır.",
  "assistantMemory.filter.archived": "Arşivlenmiş hafızayı dahil et",
  "assistantMemory.filter.archivedHint": "Daha önce etkin kullanımdan kaldırdığınız öğeleri gösterir.",
  "assistantMemory.filter.accepted": "Yalnızca kabul edilenler",
  "assistantMemory.filter.acceptedHint": "Görünümü açıkça onayladığınız anılarla sınırlar.",
  "assistantMemory.memos.title": "Hatırlanan bağlam",
  "assistantMemory.memos.description": "Burada sizden gizlenen hiçbir şey yoktur. Her öğeyi inceleyebilir, düzeltebilir, reddedebilir, arşivleyebilir veya kalıcı olarak silebilirsiniz.",
  "assistantMemory.empty.title": "Bu görünümde asistan hafızası yok",
  "assistantMemory.empty.description": "Filtreleri değiştirin veya önce bir asistan oturumundaki bağlamı onaylayın.",
  "assistantMemory.memo.meta": "Güncelleme: {{updated}} · sona erme: {{expiry}} · revizyon: {{revision}}",
  "assistantMemory.state.proposed": "İnceleme gerekiyor",
  "assistantMemory.state.accepted": "Kabul edildi",
  "assistantMemory.state.rejected": "Reddedildi",
  "assistantMemory.kind.summary": "Özet",
  "assistantMemory.kind.standing_fact": "Kalıcı bilgi",
  "assistantMemory.sensitivity.normal": "Normal",
  "assistantMemory.sensitivity.private": "Özel",
  "assistantMemory.sensitivity.sensitive": "Hassas",
  "assistantMemory.consent.none": "Verilmedi",
  "assistantMemory.consent.granted": "Verildi",
  "assistantMemory.consent.withdrawn": "Geri çekildi",
  "assistantMemory.action.accept": "Kabul et",
  "assistantMemory.action.reject": "Reddet",
  "assistantMemory.action.archive": "Arşivle",
  "assistantMemory.action.restore": "Geri yükle",
  "assistantMemory.action.clear": "Kalıcı olarak sil",
  "assistantMemory.action.close": "Kapat",
  "assistantMemory.action.save": "Değişiklikleri kaydet",
  "assistantMemory.clear.title": "“{{title}}” kalıcı olarak silinsin mi?",
  "assistantMemory.clear.description": "Bu işlem hafızayı hemen kaldırır ve geri alınamaz. İlgili kaynak kayıtlar silinmez.",
  "assistantMemory.receipts.title": "Asistan etkinlik makbuzları",
  "assistantMemory.receipts.description": "Asistan işlemlerinin ve etkiledikleri kayıtların gizliliği koruyan denetim izi.",
  "assistantMemory.receipts.unknownOperation": "Etiketsiz asistan işlemi",
  "assistantMemory.receipts.operations": "İşlemler",
  "assistantMemory.receipts.origin.mcp_runtime": "Sunucu kaydı",
  "assistantMemory.receipts.origin.legacy_client": "Eski istemci bildirimi",
  "assistantMemory.receipts.legacyNotice": "Bu geçmiş makbuz bir istemci tarafından sağlandı. İşlem ve kayıt iddiaları süreklilik için tutuluyor ancak sunucu tarafından doğrulanmış değil.",
  "assistantMemory.receipts.risk": "Risk {{risk}}",
  "assistantMemory.receipts.meta": "{{date}} · etkilenen kayıt sayısı: {{entities}}",
  "assistantMemory.receipts.connection": "Bağlantı",
  "assistantMemory.receipts.connectionUnknown": "Bilinmeyen bağlantı",
  "assistantMemory.receipts.connectionId": "Bağlantı kimliği",
  "assistantMemory.receipts.credentialId": "Yetki kimliği",
  "assistantMemory.receipts.credential.none": "Sunucu tarafından doğrulanmış bir yetki kimliği kaydedilmedi.",
  "assistantMemory.receipts.credential.oauth": "OAuth yetkisi",
  "assistantMemory.receipts.credential.derived": "Türetilmiş yetki",
  "assistantMemory.receipts.credential.unknown": "Bilinmeyen kimlik bilgisi",
  "assistantMemory.receipts.recordedAt": "Kaydedilme zamanı",
  "assistantMemory.receipts.entities": "Etkilenen kayıtlar ({{count}})",
  "assistantMemory.receipts.noEntities": "Etkilenen kayıt referansı kaydedilmedi.",
  "assistantMemory.receipts.entityRevision": "Revizyon {{revision}}",
  "assistantMemory.receipts.entityOpen": "{{kind}} kaydını aç: {{id}}",
  "assistantMemory.receipts.undo.action": "İşlemi geri al",
  "assistantMemory.receipts.undo.title": "{{operation}} geri alınsın mı?",
  "assistantMemory.receipts.undo.description": "Exognitos, etkilenen {{entities}} kayıt için yalnızca sunucunun kaydettiği güvenli telafi işlemini çalıştırır. Bu güvenli sınır artık geçerli değilse isteği reddeder.",
  "assistantMemory.receipts.undo.confirm": "İşlemi geri al",
  "assistantMemory.receipts.undo.availableUntil": "Şu zamana kadar kullanılabilir:",
  "assistantMemory.receipts.undo.completed": "Geri alındı",
  "assistantMemory.receipts.undo.completedAt": "Tamamlanma:",
  "assistantMemory.receipts.undo.expired": "Geri alma süresi doldu",
  "assistantMemory.receipts.undo.expiredAt": "Sona erme:",
  "assistantMemory.receipts.undo.unavailable": "Otomatik geri alma kullanılamıyor",
  "assistantMemory.receipts.undo.error": "Asistan işlemi geri alınamadı.",
  "assistantMemory.receipts.empty": "Henüz asistan etkinlik makbuzu yok.",
  "assistantMemory.provenance.title": "Kayıt kaynağı",
  "assistantMemory.provenance.description": "İçeriğinin doğrudan mı, içe aktarımla mı yoksa yapay zekâ yardımıyla mı oluştuğunu görmek için bir kaydı arayın.",
  "assistantMemory.provenance.entityType": "Kayıt türü",
  "assistantMemory.provenance.entityId": "Kayıt kimliği",
  "assistantMemory.provenance.lookup": "Kaydı izle",
  "assistantMemory.provenance.empty": "Bu kayıt için kaynak girdisi bulunamadı.",
  "assistantMemory.provenance.contribution": "Yapay zekâ katkısı: {{contribution}} · sağlayıcı: {{provider}} · model: {{model}}",
  "assistantMemory.edit.title": "Asistan hafızasını incele",
  "assistantMemory.edit.description": "Düzenleme ve izin seçimleriniz asistanın elindeki mevcut sürümün yerini alır.",
  "assistantMemory.edit.memoTitle": "Hafıza başlığı",
  "assistantMemory.edit.body": "Hatırlanan bağlam",
  "assistantMemory.edit.sensitivity": "Hassasiyet",
  "assistantMemory.edit.consent": "Kullanım izni",
  "assistantMemory.edit.expiresAt": "Sona erme zamanı",
  "assistantMemory.edit.reviewAt": "Yeniden inceleme zamanı",
  "assistantMemory.edit.sourceTitle": "Kaynak ve revizyon",
  "assistantMemory.edit.sourceDescription": "{{count}} kaynak referansına dayanıyor. Mevcut revizyon: {{revision}}."
}
